import { GlobalMXContext } from '~/providers/mx-global-context/global-mx.context';
import {
    ensureGlobalMXContextInit,
    initGlobalMXContext
} from '~/providers/mx-global-context/global-mx-context.utils';

let globalMXContext: GlobalMXContext = null;

export function init(): GlobalMXContext {
    globalMXContext = initGlobalMXContext({
        currentGlobalContext: globalMXContext
    });

    return globalMXContext;
}

// for test cleanup
export function cleanup() {
    globalMXContext = null;
}

export function getGlobalMXContext() {
    ensureGlobalMXContextInit(globalMXContext);

    return globalMXContext;
}
